// RESERVED for a follow-up eval-telemetry pass, intentionally declared but NOT
// yet emitted (so they aren't mistaken for dead code):
//   - "stone_review_completed": fires once when the reader closes out the rail.
//   - "stone_report_line_edited": fires when the composed report line is hand-edited.
//   - per-card `msSinceCardFocus` timing on stone_verdict/stone_attr_edit payloads.
// Do NOT delete these — wiring lands with the eval-telemetry work.
export type StoneEventType =
  | "stone_surface_opened"
  | "stone_verdict"
  | "stone_attr_edit"
  | "stone_report_line_edited"
  | "stone_review_completed";

export interface StoneEvent {
  type: StoneEventType;
  payload: Record<string, unknown>;
}

export function buildStoneEvent(
  type: StoneEventType,
  payload: Record<string, unknown>,
): StoneEvent {
  return { type, payload };
}

export function emitStoneEvent(event: StoneEvent): void {
  try {
    const body = JSON.stringify({ ...event, ts: new Date().toISOString() });
    if (import.meta.env.DEV) console.info("[stone-event]", event.type, event.payload);
    if (typeof navigator !== "undefined" && "sendBeacon" in navigator) {
      navigator.sendBeacon("/api/events/stone", body);
    }
  } catch (err) {
    console.error("[stone-event] emit failed", err); // never throw into the UI
  }
}
